import { render } from "./AGDespachosIndex.vue?vue&type=template&id=4f7f22cc"
import script from "./AGDespachosIndex.vue?vue&type=script&lang=js"
export * from "./AGDespachosIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/despachos/AGDespachosIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f7f22cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f7f22cc', __exports__)) {
    api.reload('4f7f22cc', __exports__)
  }
  
  module.hot.accept("./AGDespachosIndex.vue?vue&type=template&id=4f7f22cc", () => {
    api.rerender('4f7f22cc', render)
  })

}


export default __exports__